export default __webpack_public_path__ + "static/media/cooking.c46f8f7b.png";